// rm-progress-bubble.js — circular play-count progress indicator.
//
// Mirrors `Assets/_App/UI/Components/ProgressBubble.cs`. Renders a ring
// showing `playCount / requiredPlays` for an item in a list. STUB.

import { RMComponent } from "../core/component.js";
import { html } from "../core/html.js";

export class RMProgressBubble extends RMComponent {
  static props = ["playCount", "requiredPlays"];
  /** @type {number} */ playCount = 0;
  /** @type {number} */ requiredPlays = 1;

  static styles = `
    :host { display: inline-flex; align-items: center; justify-content: center; width: 1.5rem; height: 1.5rem; }
    svg { width: 100%; height: 100%; }
    circle.bg { stroke: var(--rm-border); fill: none; stroke-width: 2; }
    circle.fg { stroke: var(--rm-accent); fill: none; stroke-width: 2; transform: rotate(-90deg); transform-origin: center; transition: stroke-dashoffset 200ms ease; }
  `;

  render() {
    const total = Math.max(1, Number(this.requiredPlays) || 1);
    const done = Math.max(0, Math.min(total, Number(this.playCount) || 0));
    const frac = done / total;
    const r = 9;
    const c = 2 * Math.PI * r;
    const offset = c * (1 - frac);
    return html`
      <svg viewBox="0 0 24 24">
        <circle class="bg" cx="12" cy="12" r="${r}"></circle>
        <circle class="fg" cx="12" cy="12" r="${r}" stroke-dasharray="${c}" stroke-dashoffset="${offset}"></circle>
      </svg>
    `;
  }
}
